import React from 'react';
import { fromPairs, map, get, isEmpty, isEqual, filter } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { popover } from 'modules/popover';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { addEditCommunicationSettings as AddEditCommunicationSettings } from 'ui/views/widgets/addEditCommunicationSettings';
 *
 * // render
 * <AddEditCommunicationSettings propName='propValue'/>
 */
export const addEditCommunicationSettings = ( props ) => {

    const actions = filter( props.actions, ( action ) => {
        if( 'add' === props.mode ) {
            return 'edit' !== action.name;
        } else{
            return 'save' !== action.name;
        }
    } );
    
    return (
        <div className='ui-add-edit-communication-settings'>
            <div className='ui-add-edit-communication-settings__header'>

                {/* title for the modal */}
                <div className='ui-add-edit-communication-settings__header__title'>
                    { 'add' === props.mode ? getLabel( props.addTitle ) : getLabel( props.editTitle ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-add-edit-communication-settings__body'>

				{/* title for the drug preference */}
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.itemData } // default values
                    isValid={ false }
                     callingfrom="contachtInform"
                    mode={ props.mode }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            popover.close();
                            props.onSumbitClick( {
                                id: ! isEmpty( props.itemData ) ? props.itemData.id : null,
                                type: values.type,
                                contact: values.contact
                            } );
                        }
                    } }
                >
                    { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                        // check if options object is available
                        const options = get( props, 'values.options', {} );

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-add-edit-communication-settings__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    // check if field options are available
                                    const fieldOptionsKey = get( field, 'options', '' );
                                    const fieldOptions = ( options && fieldOptionsKey ) ? get( options, fieldOptionsKey ) : [];
                                    
                                    return (
                                        <field.view
                                            className='ui-add-edit-communication-settings__body__form__field'
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ fieldOptions }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-add-edit-communication-settings__body__form__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                disabled={ 'cancel' !== action.name ? !isValid : false }
                                                className='ui-add-edit-communication-settings__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {
                                                    popover.close();
                                                    props.onCancelClick();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
			</div>
        </div>
    );
};

// set display name
addEditCommunicationSettings.displayName = 'addEditCommunicationSettings';

// set default props
addEditCommunicationSettings.defaultProps = {};

// prop types
addEditCommunicationSettings.propTypes = {};
